import ks from "@shared/kalmstromShared4";
import { IListDefinition } from "../DBInterfaces";
import DBState from "../DBState";
import DBModalManager from "../DBModalManager";
import DBOutputSidebar from "../DBOutputSidebar";
import DBStringUtils from "../DBStringUtils";

export default class DBGeneratorJSON {

    public static GenerateJSON = (): any => {
        if (ks.kErrorMode === true) { return null; }
        try {
            const MapList = (list: IListDefinition): any => {
                return DBGeneratorJSON.BuildListObject(list);
            };
            const lists: any[] = DBState.Lists.map(MapList);
            return { lists: lists };
        } catch (e) {
            ks.kGlobalErrorHandler(e, "DBGeneratorJSON.GenerateJSON");
            return null;
        }
    };

    private static BuildListObject = (list: IListDefinition): any => {
        if (ks.kErrorMode === true) { return null; }
        try {
            const obj: any = {
                title: list.Title,
                listType: list.ListType || "List",
                listTemplate: list.ListTemplate || 100,
                properties: list.Properties
            };

            const hasSettings: boolean = list.Settings !== null && list.Settings !== undefined && Object.keys(list.Settings).length > 0;
            if (hasSettings) { obj.settings = list.Settings; }

            if (list.LibraryType) { obj.libraryType = list.LibraryType; }

            const hasData: boolean = list.Data !== null && list.Data !== undefined && list.Data.length > 0;
            if (hasData) { obj.data = list.Data; }

            const hasViews: boolean = list.Views !== null && list.Views !== undefined && list.Views.length > 0;
            if (hasViews) { obj.views = list.Views; }

            if (list.UseContentType) {
                obj.useContentType = true;
                obj.contentTypeName = DBStringUtils.GetContentTypeName(list);
                obj.contentTypeGroup = list.ContentTypeGroup || "Custom Content Types";
            }

            return obj;
        } catch (e) {
            ks.kGlobalErrorHandler(e, "DBGeneratorJSON.BuildListObject");
            return null;
        }
    };

    public static ShowJSON = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            const appCode: string = DBState.GetAppCode();
            const json: any = DBGeneratorJSON.GenerateJSON();
            if (json === null) { return; }
            const formatted: string = JSON.stringify(json, null, 2);
            const filename: string = appCode + "-schema.json";
            DBOutputSidebar.ShowOutputSidebar("JSON Schema", formatted, filename, "application/json");
        } catch (e) {
            ks.kGlobalErrorHandler(e, "DBGeneratorJSON.ShowJSON");
        }
    };

    public static CopyJSON = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            const json: any = DBGeneratorJSON.GenerateJSON();
            if (json === null) { return; }
            const formatted: string = JSON.stringify(json, null, 2);

            const OnCopySuccess = (): void => {
                DBModalManager.ShowToast("JSON copied to clipboard", "success");
            };
            const OnCopyError = (): void => {
                DBModalManager.ShowToast("Failed to copy JSON to clipboard", "error");
            };
            navigator.clipboard.writeText(formatted).then(OnCopySuccess).catch(OnCopyError);
        } catch (e) {
            ks.kGlobalErrorHandler(e, "DBGeneratorJSON.CopyJSON");
        }
    };

    public static ExportSchema = (): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            const appCode: string = DBState.GetAppCode();
            const json: any = DBGeneratorJSON.GenerateJSON();
            if (json === null) { return; }
            const formatted: string = JSON.stringify(json, null, 2);
            const blob: Blob = new Blob([formatted], { type: "application/json" });
            const url: string = URL.createObjectURL(blob);
            const a: HTMLAnchorElement = document.createElement("a");
            a.href = url;
            a.download = appCode + "-schema.json";
            a.click();
            URL.revokeObjectURL(url);
            DBModalManager.ShowToast("Schema exported", "success");
        } catch (e) {
            ks.kGlobalErrorHandler(e, "DBGeneratorJSON.ExportSchema");
        }
    };

    public static ExportSingleListJSON = (listId: string): void => {
        if (ks.kErrorMode === true) { return; }
        try {
            const list: IListDefinition | null = DBState.FindList(listId);
            if (list === null) {
                DBModalManager.ShowToast("List not found", "error");
                return;
            }
            const listObj: any = DBGeneratorJSON.BuildListObject(list);
            if (listObj === null) { return; }
            const json: any = { lists: [listObj] };
            const formatted: string = JSON.stringify(json, null, 2);
            const blob: Blob = new Blob([formatted], { type: "application/json" });
            const url: string = URL.createObjectURL(blob);
            const a: HTMLAnchorElement = document.createElement("a");
            a.href = url;
            a.download = list.Title + "-schema.json";
            a.click();
            URL.revokeObjectURL(url);
            DBModalManager.ShowToast("List schema exported", "success");
        } catch (e) {
            ks.kGlobalErrorHandler(e, "DBGeneratorJSON.ExportSingleListJSON");
        }
    };
}
